'use client';

import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

import { getOptions } from '@/app/_shared/i18n/core/options';

i18next
	.use(initReactI18next)
	.use(LanguageDetector)
	.use(
		resourcesToBackend(
			(language: string, namespace: string) =>
				import(`../../generated/locales/${language}/${namespace}.json`),
		),
	)
	.init(getOptions());

export default i18next;
